
export const LOCAL_STORAGE_KEYES  = {
    'BUM_TABLE_SETTINGS' : 'bum_table_settings'
}